import FooterFaqs from "../components/faqs/footer";
import { useEffect } from "react";
import Header from "../components/faqs/header";
import Items from "../components/faqs/items";
import MenuLateralOpc from "../components/faqs/menuLateralOpc";
import { ThemeProvider } from "../contexts/ThemeContext";

import "../css/faqs.css";

const Faqs = () => {

  useEffect(() => {
    if (!document.querySelector("#quick-launch-script")) {
      const script = document.createElement("script");
      script.src = "https://webservice.possumus.tech/quicklaunch/quicklaunch.js"; // Replace with actual URL
      script.async = true;
      script.id = "quick-launch-script";
      document.body.appendChild(script);
    }
  }, []);

  return (
    <>
      <ThemeProvider>
        <div id="faqs" className="content-container">
          <MenuLateralOpc />
          <Header
            title="Faqs"
            description="Numerosos estudios con escaso fundamento científico
            indican que hay 92,7% de posibilidades que lo que
            busques está acá."
            col={6}
            paddingLeft={0}
            offset={3}
          />
          <Items />
          <FooterFaqs />
          <quick-launch></quick-launch>
        </div>
      </ThemeProvider>
    </>
  );
};

export default Faqs;
